import React from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../utils/theme';

const ProcessSteps = ({ currentStep }) => {
  const { t } = useTranslation('upload');

  const steps = [
    { id: 1, label: t('steps.upload') },
    { id: 2, label: t('steps.invoicing') },
    { id: 3, label: t('steps.payment') },
  ];

  return (
    <div className="bg-background-primary">
      <div className={theme.card.base + ' flex justify-around mb-4'}>
        {steps.map((step) => (
          <div
            key={step.id}
            className={`${theme.text.small} font-bold px-4 py-2 rounded-full ${
              step.id <= currentStep ? 'bg-primary text-white' : 'bg-background-secondary text-text-secondary'
            }`}
          >
            {step.id}. {step.label}
          </div>
        ))}
      </div>

      <div className="relative h-2 bg-background-secondary rounded-full mb-8">
        <div
          className="absolute top-0 left-0 h-full bg-primary rounded-full"
          style={{ width: `${(currentStep / steps.length) * 100}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProcessSteps;